import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag, faTachometerAlt, faLaptop, faTable, faFile } from '@fortawesome/free-solid-svg-icons';
import userImage from '../assets/admin/img/user.png';
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const user =  JSON.parse(localStorage.getItem('user'));

  return (
    <div className="sidebar pe-4 pb-3 bg-light">
      <nav className="navbar bg-light navbar-light">
        <Link to="/" className="navbar-brand mx-4 mb-3">
          <h3 className="text-primary">
            <FontAwesomeIcon icon={faHashtag} className="me-2" />
            MAHA-KUMBH
          </h3>
        </Link>
        <div className="d-flex align-items-center ms-4 mb-4">
          <div className="position-relative">
            <img
              className="rounded-circle"
              src={userImage}
              alt="User"
              style={{ width: '40px', height: '40px' }}
            />
            <div className="bg-success rounded-circle border border-2 border-white position-absolute end-0 bottom-0 p-1"></div>
          </div>
          <div className="ms-3">
            <h6 className="mb-0">{user ? `${user.name}` : 'Guest'}</h6>
            <span>{`${user.designation}`}</span>
          </div>
        </div>
        <div className="navbar-nav w-100">
          {/* Dashboard Link */}
          <Link
            to="/admin"
            className={`nav-item nav-link ${location.pathname === "/admin" ? "active" : ""}`}
          >
            <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
            Dashboard
          </Link>

          {/* Dropdown Menu */}
          {/* <div className="nav-item dropdown">
            <a
              href="#"
              className={`nav-link dropdown-toggle ${
                /\/river$|\/drains$|\/stp$/.test(location.pathname) ? "active" : ""
              }`}
              id="elementsDropdown"
              data-bs-toggle="dropdown"
              aria-expanded={`${ /\/river$|\/drains$|\/stp$/.test(location.pathname) ? "true" : "false" }`}
            >
              <FontAwesomeIcon icon={faLaptop} className="me-2" />
              Onsite Reports
            </a>
            <ul className={`dropdown-menu ${ /\/river$|\/drains$|\/stp$/.test(location.pathname) ? "show" : "" }`} aria-labelledby="elementsDropdown">
            
              <li>
                <Link
                  className={`dropdown-item ${location.pathname === "/admin/river" ? "active" : ""}`}
                  to="/admin/river"
                >
                  River
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item ${location.pathname === "/admin/drains" ? "active" : ""}`}
                  to="/admin/drains"
                >
                  Drains
                </Link>
              </li>
              <li>
                <Link
                  className={`dropdown-item ${location.pathname === "/admin/stp" ? "active" : ""}`}
                  to="/admin/stp"
                >
                  STP
                </Link>
              </li>
            </ul>
          </div> */}


          <Link
            to="/admin/onsiteReports"
            className={`nav-item nav-link ${location.pathname === "/admin/onsiteReports" ? "active" : ""}`}
          >
            <FontAwesomeIcon icon={faFile} className="me-2" />
            Onsite Reports
          </Link>

          {/* Tables Link */}
          <Link
            to="/admin/table"
            className={`nav-item nav-link ${location.pathname === "/admin/table" ? "active" : ""}`}
          >
            <FontAwesomeIcon icon={faTable} className="me-2" />
            Tables
          </Link>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
